import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import NguonVonApi from "service/nguonVonApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

export const LichSuGiaoDich = ({ item, customerId }) => {
  const searchInit = {
    customerId: customerId,
    pageIndex: 1,
    pageSize: 5,
  };
  const [dataSearchLichSuGiaoDich, UpdateDataSearchLichSuGiaoDich] =
    useState(searchInit);
  const dataInit = {
    List: [],
    TongBanGhi: 0,
    TongSoTienVon: 0,
  };
  const [dataLichSuGiaoDich, setDataLichSuGiaoDich] = useState(dataInit);

  useEffect(() => {
    UpdateDataSearchLichSuGiaoDich({
      ...dataSearchLichSuGiaoDich,
      customerId: customerId,
      pageIndex: 1,
      pageSize: 5,
    });
    NguonVonApi.lichSuNguonVon(
      dataSearchLichSuGiaoDich.customerId,
      dataSearchLichSuGiaoDich.pageIndex,
      dataSearchLichSuGiaoDich.pageSize
    ).then((response) => {
      setDataLichSuGiaoDich({
        ...dataLichSuGiaoDich,
        List: response.data.List,
        TongBanGhi: response.data.TongBanGhi,
        TongSoTienVon: response.data.TongSoTienVon,
      });
    });
  }, []);

  const PhanTrang = (index) => {
    dataSearchLichSuGiaoDich.pageIndex = index;
    NguonVonApi.lichSuNguonVon(
      dataSearchLichSuGiaoDich.customerId,
      dataSearchLichSuGiaoDich.pageIndex,
      dataSearchLichSuGiaoDich.pageSize
    ).then((response) => {
      setDataLichSuGiaoDich({
        ...dataLichSuGiaoDich,
        List: response.data.List,
        TongBanGhi: response.data.TongBanGhi,
      });
    });
  };

  const listItem = () => {
    return (
      dataLichSuGiaoDich.List != null &&
      dataLichSuGiaoDich.List.map((item, index) => {
        return (
          <>
            <tr className="active">
              <th scope="row">{item.IndexId}</th>
              <td>{getDate(item.CreatedTime)}</td>
              <td>
                <a href={() => false}>{item.ThuChiCode}</a>
              </td>
              <td className="text-left">{item.UpdatedUser}</td>
              <td className="text-right">
                <span className="color-do">{formatNumber(item.Value)}</span>
              </td>
              <td className="">
                <span className="">{item.TypeName}</span>
              </td>
              <td className="text-left">{item.Note}</td>
            </tr>
          </>
        );
      })
    );
  };

  return (
    <>
      <div
        id="headingCollapse25312"
        className="card-header"
        href="#collapse25312"
        aria-expanded="true"
        aria-controls="collapse25312"
      >
        <a className="card-title lead info collapsed" href={() => false}>
          <h3>Lịch sử giao dịch</h3>
        </a>
      </div>
      <div className="card-collapse collapse show">
        <div className="card-content">
          <div className="card-body">
            <div className="table-responsive table-2">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th className="w-stt">STT</th>
                    <th className="w-10">Ngày giao dịch</th>
                    <th className="">Mã phiếu</th>
                    <th className="text-left">Nhân viên giao dịch</th>

                    <th className="w-20 text-right">
                      Số tiền vốn
                      <br />
                      <span className="color-do-bold">
                        {formatNumber(dataLichSuGiaoDich.TongSoTienVon)}
                      </span>
                    </th>
                    <th className="w-10">Trạng thái</th>
                    <th className="text-left">Ghi chú</th>
                  </tr>
                </thead>
                <tbody>{listItem()}</tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="footer-page-new">
          <div className="row">
            <div className="col-sm-12  col-md-6">
              <span className="color7">
                {dataLichSuGiaoDich.TongBanGhi === 0 ? (
                  "Hiển thị 0 - 0 / Tổng số 0"
                ) : (
                  <>
                    Hiển thị{" "}
                    {(dataSearchLichSuGiaoDich.pageIndex - 1) *
                      dataSearchLichSuGiaoDich.pageSize +
                      1}{" "}
                    -{" "}
                    {Math.min(
                      dataSearchLichSuGiaoDich.pageIndex *
                        dataSearchLichSuGiaoDich.pageSize,
                      dataLichSuGiaoDich.TongBanGhi
                    )}{" "}
                    / Tổng số {dataLichSuGiaoDich.TongBanGhi}
                  </>
                )}
              </span>
            </div>
            <div className="col-sm-12  col-md-6">
              <div
                className={
                  "paniation-new paniation-new1 d-flex justify-content-center " +
                  (dataLichSuGiaoDich.TongBanGhi === 0 ? "hidden" : "")
                }
                style={{ float: "right" }}
              >
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={dataSearchLichSuGiaoDich.pageIndex}
                    itemsCountPerPage={dataSearchLichSuGiaoDich.pageSize}
                    totalItemsCount={dataLichSuGiaoDich.TongBanGhi}
                    pageRangeDisplayed={5}
                    onChange={PhanTrang}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
